import React from "react";
import { SECTION_HORIZONTAL_SPACING } from "../../styles/spacing";

type SectionHorizontalSpaceProps = {};

export const SectionHorizontalSpace = (props: SectionHorizontalSpaceProps) => {
  return <div style={{ width: SECTION_HORIZONTAL_SPACING }} />;
};
